import React from 'react';
import { styled } from '@mui/system';
const Block = styled('div')({
  border: "1.5px solid #F1F1F1",
  paddingLeft: 30,
  paddingRight: 30,
  borderRadius: 5,
  marginTop: 20,
  backgroundColor: '#FFFFFF'
});
const BlockContent = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Block, props, props.children));
export default BlockContent;